import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-checkbox-list',
  styleUrls: ['form-checkbox-list.component.scss'],
  templateUrl: './form-checkbox-list.component.html',
  imports: [FormsModule, ReactiveFormsModule],
})
export class FormCheckboxListComponent extends FieldBaseComponent {
  get controls() {
    return (<any> this.formGroup.controls[this.config.name]).controls;
  }

  get validation() {
    return this.controls.find((valid: { value: boolean; }) => valid.value === true) ? true : false;
  }
}
